import PropTypes from 'prop-types';
import React from 'react';
import { motion } from 'framer-motion';
import cn from 'classnames';

import { cls } from '@mssgme/helpers';

import styles from './ModalSheet.scss';

export function ModalSheetPane({ header, children, motionProps, padding = true, ...rest }) {
    const Component = motionProps ? motion.div : 'div';

    return (
        <Component className={cn(styles.sheetyPane, header && styles.hasHeader)} {...motionProps}>
            {header && <Component className={styles.header}>{header}</Component>}

            <Component {...cls([styles.content, padding && styles.padded], rest)}>
                {children}
            </Component>
        </Component>
    );
}

ModalSheetPane.propTypes = {
    header: PropTypes.any,
    children: PropTypes.any.isRequired,
    padding: PropTypes.bool,
    motionProps: PropTypes.any,
    style: PropTypes.any,
};
